module.exports = __webpack_public_path__ + "img/impostor-bg-1.7e957181.png";